import Talker from 'talker.js'
import angular from 'angular'

import { err2str } from '../utils/bits'

angular
  .module('ggs.gallery-styler-new')
  .factory('GSNServerManager', GSNServerManagerProvider)

function GSNServerManagerProvider(
  qh,
  DefineMethod,
  DefineHandler) {

  return function GSNServerManager(stylerNew) {

    const sign = 'GSNServerManager'
    const server = {}

    server.wrapH = DefineHandler(sign)
    server.wrapM = DefineMethod(sign)

    server.ready = null
    server.talker = null

    server.wrapH('talkerMessageHandler', (message) => {
      const methodName = message.namespace

      const method = stylerNew[methodName]
      return server
        .ready
        .then(() => method(message.data))
        .then(
          (res) => message.terminate({ isDone: true, isFail: false, resp: res }),
          (err) => message.terminate({ isDone: false, isFail: true, resp: err2str(err) }))
    })

    server.wrapM('init', () => {
      server.ready = qh.delay(1e3)
      server.talker = new Talker(window.parent, '*')
      server.talker.onMessage = server.talkerMessageHandler
    })

    server.wrapM('destroy', () => {
      server.talker.destroy()
    })

    return server
  }
}
